import { render, staticRenderFns } from "./DDSDashboardGuide.vue?vue&type=template&id=b62574a6"
import script from "./DDSDashboardGuide.vue?vue&type=script&lang=js"
export * from "./DDSDashboardGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports